import { render, staticRenderFns } from "./Corners.vue?vue&type=template&id=94ebd0d0&scoped=true&"
import script from "./Corners.vue?vue&type=script&lang=js&"
export * from "./Corners.vue?vue&type=script&lang=js&"
import style0 from "./Corners.vue?vue&type=style&index=0&id=94ebd0d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ebd0d0",
  null
  
)

export default component.exports